import styled, { keyframes } from 'styled-components'
import { RADOM_COLORS } from '../util/Constants'

const Spin = keyframes`
  from {
      transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const Spinner = styled.div`
  width: 20px;
  height: 20px;
  margin: 0;
  background: transparent;
  color: ${RADOM_COLORS.GRAY_DARKEST};
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-left-color: currentColor;
  border-radius: 50%;
  animation: .5s ${Spin} linear infinite;
`

export default Spinner
